import CustomGreetings from "./CustomGreetings/index.js";
import BulkAssign from "./BulkAssign/index.js";
import Extensions from "./Extensions/index.js";
class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/call-recording`;
    }
    /**
     * Returns call recording settings.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-recording
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyInfo
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates current call recording settings.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-recording
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyInfo
     */
    async put(callRecordingSettingsResource, restRequestConfig) {
        const r = await this.rc.put(this.path(), callRecordingSettingsResource, undefined, restRequestConfig);
        return r.data;
    }
    extensions() {
        return new Extensions(this);
    }
    bulkAssign() {
        return new BulkAssign(this);
    }
    customGreetings(greetingId = null) {
        return new CustomGreetings(this, greetingId);
    }
}
export default Index;
